import React, { useRef } from 'react';
import './App.css';
import MainPage from './components/MainPage';
import { store } from './store'
import { Provider } from 'react-redux';
import SocialBar from './components/SocialBar';
import CopyrightText from './components/CopyrightText';

const App: React.FC = () => {
  return (
    <Provider store={store}>
        <div className="App">
            <MainPage />
            <table className="MainPageFooter">
              <tbody>
                <tr className="MainPageTableRow"><SocialBar /></tr>
                <tr className="MainPageTableRow"><CopyrightText /></tr>
              </tbody>
            </table>
        </div>
    </Provider>
  );
}

export default App;